"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { PageTranslations } from "@/modules/layouts/contexts/foLayout"
import type { FunctionComponent } from "react"

import { usePathname } from "next/navigation"

import { AVAILABLE_LOCALES } from "@/modules/i18n/constants"
import { PUBLIC_LOCALES } from "@/modules/locales/constants"
import { isHome } from "@/modules/routing/helpers/isPage"

import { AppLocalesDropdownItem } from "./AppLocalesDropdownItem"

import styles from "./LocalesDropdown.module.css"

type AppLocalesListProps = {
  careerCenterConfLocales?: I18nLocale[]
  hasCustomSchoolTheme: boolean
  isLogged: boolean
  locale: I18nLocale
  locales?: I18nLocale[]
  localeSelectorTranslations?: Record<I18nLocale, string>
  pageTranslations?: PageTranslations
}

export const AppLocalesList: FunctionComponent<AppLocalesListProps> = ({
  careerCenterConfLocales,
  hasCustomSchoolTheme,
  isLogged,
  locale,
  locales,
  localeSelectorTranslations,
  pageTranslations,
}) => {
  const pathname = usePathname()

  let localesToDisplay: I18nLocale[] = PUBLIC_LOCALES

  if (!pageTranslations) {
    if (hasCustomSchoolTheme && !!isLogged && locales) {
      localesToDisplay = locales
    } else if (hasCustomSchoolTheme) {
      localesToDisplay = careerCenterConfLocales || []
    } else if (isHome(pathname)) {
      localesToDisplay = AVAILABLE_LOCALES
    }
  }

  return (
    <ul className={`js-DropdownMenu-submenu ${styles["hdr-DropdownMenu-submenu"]}`}>
      {pageTranslations
        ? Object.entries(pageTranslations)
            .filter(([localeToDisplay]) => locale !== localeToDisplay)
            .map(([localeToDisplay, href]) => (
              <AppLocalesDropdownItem
                currentLocale={locale}
                href={href}
                key={href}
                locale={localeToDisplay as I18nLocale}
              />
            ))
        : localesToDisplay
            // Do NOT include the current locale in the list
            .filter(localeToDisplay => locale !== localeToDisplay)
            .map(localeToDisplay => (
              <AppLocalesDropdownItem
                currentLocale={locale}
                key={localeToDisplay}
                locale={localeToDisplay}
                translation={localeSelectorTranslations && localeSelectorTranslations[localeToDisplay]}
              />
            ))}
    </ul>
  )
}
